// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-popular[data-v-04675cd2]{flex-direction:column;padding:var(--padding-m);background:var(--general-bg-card);border-radius:var(--radius-l)}.filter-popular[data-v-04675cd2],.filter-popular__list[data-v-04675cd2]{display:flex;grid-gap:var(--spaces-s);gap:var(--spaces-s)}.filter-popular__list[data-v-04675cd2]{flex-wrap:wrap}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
